import { fakeAccount } from "./fakeAccount";

export function createFakeAuth() {
    const fakeMsal = {
        getAllAccounts() {
            return [fakeAccount];
        },

        getActiveAccount() {
            return fakeAccount;
        },

        setActiveAccount() {},

        acquireTokenSilent() {
            return Promise.resolve({
                idToken: "fake-token",
                account: fakeAccount
            });
        },

        loginRedirect() {
            return Promise.resolve();
        },

        logoutRedirect() {
            return Promise.resolve();
        }
    };

    return {
        msalInstance: fakeMsal,
        account: fakeAccount,
        idToken: "fake-token",
        scopes: [],
        redirectUri: window.location.origin
    };
}

export function mockUserData(setState) {
    setState({
      mymUsers: [fakeAccount],
      selectedUser: [fakeAccount],
      selectedUserID: fakeAccount.clientID,
      tokenUser: fakeAccount.clientID,
      parentUser: fakeAccount,
      loading: false,
    });
};
